import { PresentationBundleKind } from '@/types/schema';

/** Waterfall bundles require presenter access for insertion and configuration. */
export function canAddPresentationBundle(
  kind: PresentationBundleKind,
  canPresentEstateWaterfall: boolean | undefined
): boolean {
  if (
    kind === PresentationBundleKind.WaterfallOverviewBundle ||
    kind === PresentationBundleKind.WaterfallComparisonBundle
  ) {
    return canPresentEstateWaterfall === true;
  }
  return true;
}
